
import { Component, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getStaFeeTrailPage } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";

@Component({
  components: {}
})
export default class PiPileRateChangeRecord extends mixins(tableMaxHeight) {
  @Prop({ default: "" }) private staPkId!: string;
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10,
    staPkId: "",
    globalOrder: ""
  };
  private loading = false;
  private privilegeVoObj: objAny = {};
  private total = 0;

  private tableList: objAny[] = [];

  private tableColumns: objAny[] = [
    {
      title: i18n.t("pileInfoDetail.oldFeeName"),
      key: "oldFeeName",
      minWidth: 110
    },

    {
      title: i18n.t("pileInfoDetail.newFeeName"),
      key: "newFeeName",
      minWidth: 130
    },
    {
      title: i18n.t("pileInfoDetail.replaceTime"),
      key: "replaceTime",
      minWidth: 100
    }
    // {
    //   title: "是否成功",
    //   key: "staName",
    //   minWidth: 120,
    // },
    // {
    //   title: "操作帐号",
    //   key: "staName",
    //   minWidth: 120,
    // },
  ];

  public tableChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    this.formInline.staPkId = this.staPkId;
    const params = this.formDataNull(this.formInline);
    const ret = await getStaFeeTrailPage(params);
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
    }
    this.loading = false;
  }

  public onClickSearch(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  mounted(): void {
    this.privilegeVoObj = this.$route.meta?.privilegeVoObj;
    this.getTableList();
  }
}
